import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { Parametria, ParametriaType } from '../models/parametria';
import { AgilcredBaseService } from './agilcred-base.service';

@Injectable({
    providedIn: 'root'
})
export class ParametriaService extends AgilcredBaseService {
    public getParametria<T = string>(parameter: ParametriaType): Observable<Parametria<T>> {
        const params = new HttpParams({ fromObject: { name: parameter } });
        return this.get(`parametria`, params).pipe(map(({ data }) => data));
    }

    public isParametriaRuleEnabled(parameter: ParametriaType): Observable<boolean> {
        return this.getParametria<boolean>(parameter).pipe(map(({ valor }) => valor));
    }
}
